/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import '../UserList/UserList.scss';
import './Affiliates.scss';
import PropTypes from 'prop-types';
import icSearch from '../../../images/ic_search.png';
import actions from '../../../redux/actions';
import Loading from '../../../common/components/Loading/Loading';
import moment from 'moment';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Tooltip} from '@mui/material';
import Countdown from 'react-countdown';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const Affiliates = (props) => {
    const {
        name,
        title,
        affiliates,
        getAffiliate,
        getAffiliatesState,
        cleanAffiliates,
        cleanGetAffiliatesState,
        showSidebar,
    } = props;

    useEffect(() => {
        cleanSearch();
        setFirstView(true);
        // eslint-disable-next-line
    }, []);

    moment.locale('es');

    const [search, setSearch] = useState('');
    const [firstView, setFirstView] = useState(true);
    const [searchTag, setSearchTag] = useState('document');

    const handleSearch = () => {
        getAffiliate(search, searchTag);
        setFirstView(false);
    };

    const tagNames = {
        document: 'Documento',
        affiliateNumber: 'Credencial',
    };

    const renderer = ({hours, minutes, seconds, completed}) => {
        if (!completed) {
            // Render a countdown
            return (
                <div className="countDownContainer">
                    <span className="countDown">Por favor intente nuevamente en: </span>
                    {minutes > 0 && <span className="countDown">{minutes + ' minuto' + (minutes > 1 ? 's, ' : ', ')}</span>}
                    <span className="countDown">{seconds} segundos</span>
                </div>);
        } else {
            cleanGetAffiliatesState();
            return null;
        }
    };

    const cleanSearch = () => {
        cleanAffiliates();
        setSearch('');
        setFirstView(true);
    };

    useEffect(()=> {
        search && handleSearch();
    }, [searchTag]);

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>

            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                </div>
                <div className="ul-div-form">
                    <div className="vu-form">
                        <div className="af-div-container">
                            <div className="vu-row-data">
                                <div className="ul-div-searchAffiliates">
                                    <div className="ul-div-serchCont">
                                        <div className="ul-div-tagSel">
                                            <select
                                                className="ul-div-searchbar"
                                                style={{width: 200}}
                                                onChange={(e) => setSearchTag(e.target.value)}
                                                defaultValue={'name'}
                                            >
                                                <option value={'document'} selected="selected">{tagNames['document']}</option>
                                                <option value={'affiliateNumber'}>{tagNames['affiliateNumber']}</option>
                                            </select>
                                        </div>
                                        <div className="ul-div-searchbar">
                                            <input
                                                placeholder="Buscar afiliado"
                                                value={search}
                                                onChange={(e) => {
                                                    setSearch(e.target.value.replace(/[^\w-/]/gi, ''));
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSearch();
                                                    }
                                                }}
                                            />
                                            <button onClick={() => handleSearch()}>
                                                <img src={icSearch} alt={'search'}/>
                                            </button>
                                        </div>
                                    </div>
                                    <Ebutton classNameButton="ul-btn" onClick={() => cleanSearch()} text="Limpiar Búsqueda"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {getAffiliatesState.success && affiliates ?
                    renderAffiliates(affiliates, cleanSearch, firstView) :
                    getAffiliatesState.loading ?
                        <div className="mb-50">
                            {localStorage['affiliateRetry'] === '5' &&
                                <Countdown date={parseInt(localStorage['affiliateRetryTime'])} renderer={renderer}></Countdown>}
                            <Loading/>
                        </div> :
                        !firstView &&
                        <div className="ul-div-form vu-content">
                            <div className="vu-title column">
                                <text className="vu-name">Afiliado no encontrado</text>
                                   <text className="vu-subtext">Intente con número de {search && searchTag === `document` ? 'credencial' : 'documento'}</text>
                            </div>
                        </div>
                }
            </div>
        </div>
    );
};

const renderAffiliates = (affiliates, cleanSearch, firstView) => {
    if (affiliates.length === 0 && !firstView) {
        return (
            <div className="ul-div-form vu-content mb-50">
                <div className="vu-title">
                    <text className="vu-name">Afiliado no encontrado</text>

                    <text className="vu-row-data">Estado:
                        <Tooltip open={true} title={'Error, llamar a 08008883637'} placement="right">
                            <ClearIcon className="red-icon"/>
                        </Tooltip>
                    </text>
                </div>
            </div>
        );
    } else if (!firstView) {
        return (
            <div>
                <div className="ul-div-form vu-content mb-50">
                    <div className="vu-title">
                        <text className="vu-name">{affiliates[0]?.fullName}</text>
                    </div>
                    <form className="vu-form">
                        <div className="vu-fm">
                            <div className="vu-div-container">
                                <div className="vu-row-data">
                                    <text>Tipo de documento:</text>
                                    <text>{affiliates[0]?.documentType}</text>
                                </div>
                                <div className="vu-row-data">
                                    <text>Número de documento:</text>
                                    <text>{affiliates[0]?.documentNumber}</text>
                                </div>
                                {affiliates[0].status === 'Baja' && !affiliates.filter((e)=> e.downDate !== affiliates[0].downDate).length > 0 &&
                                    <div className="vu-row-data">
                                        <text>Fecha de baja: {moment(affiliates[0].downDate).format('DD/MM/YYYY')}</text>
                                    </div>
                                }
                                <div className={affiliates.length === 1 ? '' : 'cards'}>
                                    {affiliates.map((affiliate, i) => (
                                        <div key={i} className="ul-div-form vu-content mb-50">
                                            <div className="vu-title">
                                                {affiliate?.status === 'Baja' &&
                                                    <text className="vu-row-data">Estado:
                                                        <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                            <ClearIcon className="red-icon"/>
                                                        </Tooltip>
                                                    </text>}
                                                {affiliate?.status === 'Activo' && !affiliate?.dischargeDate &&
                                                    <text className="vu-row-data">Estado:
                                                        <Tooltip title="Activo">
                                                            <CheckIcon className="green-icon"/>
                                                        </Tooltip>
                                                    </text>}
                                                {affiliate?.status === 'Activo' && affiliate?.dischargeDate &&
                                                    <text className="vu-row-data">Estado:
                                                        <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                            <HelpOutlineIcon className="yellow-icon"/>
                                                        </Tooltip>
                                                    </text>}
                                                {affiliate?.status !== 'Baja' && affiliate?.status !== 'Activo' &&
                                                    <text className="vu-row-data">Estado:
                                                        <Tooltip open={true} title={affiliate?.status + ', llamar a 08008883637'} placement="right">
                                                            <WarningAmberIcon className="yellow-icon"/>
                                                        </Tooltip>
                                                    </text>}
                                            </div>
                                            <form className="vu-form">
                                                <div className="vu-fm">
                                                    <div className="vu-div-container">
                                                        {affiliate?.dischargeDate && <div className="vu-row-data">
                                                            <text>Fecha de baja:</text>
                                                            <text>{moment(affiliate?.dischargeDate).format('DD/MM/YYYY')}</text>
                                                        </div>}
                                                        <div className="vu-row-data">
                                                            <text>Credencial:</text>
                                                            <text>{affiliate?.affiliateNumber}</text>
                                                        </div>
                                                        <div className="vu-row-data">
                                                            <text>{affiliate?.plans?.length > 1 ? 'Planes: ' : 'Plan: '}</text>
                                                            <ul>
                                                                {
                                                                    affiliate?.plans?.map((plan, index) => (
                                                                        <li key={index}>
                                                                            {affiliate.status === 'Baja' ?
                                                                            <>
                                                                            {plan.name} | Fecha de baja: {moment(affiliate.downDate).format('DD/MM/YYYY')}
                                                                            </> :
                                                                            <>
                                                                            {plan.name} | Fecha de alta: {moment(plan.createdAt).format('DD/MM/YYYY')}
                                                                            </>
                                                                        }
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    affiliates: state.home.affiliates,
    getAffiliatesState: state.home.getAffiliatesState,
    showSidebar: state.common.showSidebar,
    featureFlag: state.home.setSelfState.featureFlag,
});

const mapDispatchToProps = (dispatch) => ({
    getAffiliate: (document, type) => dispatch(actions.home.getAffiliateRequest(document, type)),
    cleanAffiliates: () => dispatch(actions.home.cleanAffiliates()),
    cleanGetAffiliatesState: () => dispatch(actions.home.cleanGetAffiliatesState()),
});

Affiliates.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    affiliates: PropTypes.object,
    getAffiliatesState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Affiliates);

